var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-ton'),_vm._m(0),_c('booter-ton')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('img',{staticClass:"brand-img",attrs:{"src":require("../../../public/images/bg/7.png"),"height":"460","alt":""}})])
}]

export { render, staticRenderFns }